module.exports = __webpack_public_path__ + "static/media/countingwell-logo.02a37a9c.png";